import classNames from 'classnames';
import { Button } from 'components/Button/Button';
import { useLocale } from 'containers/App/LocaleContext';
import type React from 'react';
import { type JSX, useState } from 'react';

interface Props {
  children: React.ReactNode;
}

export const FormikAdvancedSettings = (props: Props): JSX.Element => {
  const msg = useLocale();
  const [open, setOpen] = useState(false);

  const renderAdvancedSettingsButton = () => (
    <>
      <hr className='mb-0' />
      <Button
        // Compensate padding of tertiary button to align left side with rest of content.
        // This is a workaround, see https://ipfabric.atlassian.net/browse/UX-139 .
        className={classNames('-mx-2', 'mt-4', !open && 'mb-4')}
        onClick={() => setOpen(!open)}
        variant='tertiary'
        type='button'
        size='sm'
        icon={open ? 'fa-chevron-up' : 'fa-chevron-down'}
        iconStyle='solid'
        iconPosition='right'
      >
        {open
          ? msg.discoverySettings.vendorsApi.rateLimitingSettings.hideSettings
          : msg.discoverySettings.vendorsApi.rateLimitingSettings.showSettings}
      </Button>
    </>
  );

  return (
    <>
      {renderAdvancedSettingsButton()}
      {open && props.children}
    </>
  );
};
